import { FC, Fragment, useState } from "react";
import styles from "./Answers.module.scss";
import classNames from "classnames";

const Answers: FC = () => {
    const [openedIndex, setOpenedIndex] = useState(-1);
    const handleOpen = (index: number) => {
        setOpenedIndex(index);
        if (openedIndex === index) {
            setOpenedIndex(-1);
        }
    };

    const questions = [
        {
            question: "What is nest?",
            answer: `Nest is a DEX aggregator on The Open Network (TON) blockchain designed for cryptocurrency transactions, offering additional features like fast transactions, limit orders, and other tools to make interacting with the TON blockchain easier.`,
        },
        {
            question: "Does nest have a roadmap?",
            answer: (
                <>
                    <span>The roadmap is in our telegram channel</span>
                    <a href="https://t.me/nest_dex">https://t.me/nest_dex.</a>
                </>
            ),
        },
        {
            question: "Will we have our own token?",
            answer: `Yes, the token will be released after at least half of the plans from the roadmap are finalized and after additional utilities are created for the token.
 `,
        },
        {
            question: "What are the benefits of trading through nest?",
            answer: (
                <ul>
                    <li>
                        Sometimes, due to high demand and hype around a specific asset, the interface of DEX exchanges
                        on TON may become temporarily unavailable. In such situations, transactions can be carried out
                        via NEST, giving you a higher chance of gaining an advantage over other traders.
                    </li>
                    <li>
                        NEST allows users to choose the most favorable exchange rate from all available DEX platforms on
                        TON.
                    </li>
                    <li>
                        The platform also offers a variety of tools that simplify interaction with the TON ecosystem.
                    </li>
                </ul>
            ),
        },
        {
            question: "How to start using nest?",
            answer: (
                <ul>
                    <li>
                        Click the “Connect Wallet” button. You will be prompted to select your wallet (Tonkeeper,
                        MyTonWallet, etc.) and confirm the connection;
                    </li>
                    <li>Go to the “Swap” section;</li>
                    <li>Select tokens to swap;</li>
                    <li>In the DEX interface, select the tokens you want to swap;</li>
                    <li>Enter the quantity and confirm the transaction;</li>
                    <li>Confirm the transaction in the wallet.</li>
                </ul>
            ),
        },
        {
            question: "What kind of wallets can I connect?",
            answer: (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <p>
                        You will need a cryptocurrency wallet that supports TON blockchain and is compatible with nest
                        DEX, for example:
                    </p>
                    <ul>
                        <li>Tonkeeper</li>
                        <li>MyTonWallet</li>
                        <li>Ton Space Wallet</li>
                    </ul>
                </div>
            ),
        },
        {
            question: "What is and what are the benefits of using NFT Fast?",
            answer: `NFT Fast speeds up transactions and provides the benefits of participating in promotions, raffles and etc.`,
        },
        {
            question: "What is and what are the benefits of using NFT Sniper?",
            answer: `NFT Sniper allows you to buy token before others at the stage of token creation. And also advantages of participation in promotions, raffles, etc.`,
        },
        {
            question: "How do I buy NFT Fast and NFT Sniper?",
            answer: `NFT Fast & NFT Sniper can be purchased in the NFT mint section or through the GetGems platform.`,
        },
        {
            question: "What kind of defense systems do we have?",
            answer: `We use CloudFlare from DDOS & Cache layer Redis, and a separate encrypted key database and microservices closed for external access.`,
        },
    ];

    return (
        <section className={styles.answers}>
            <h2 className={styles.headline}>Answers</h2>
            <div className={styles.items}>
                {questions.map(({ question, answer }, i) => (
                    <button
                        key={question}
                        onClick={() => handleOpen(i)}
                        className={classNames(styles.item, {
                            [styles.active]: i === openedIndex,
                        })}
                    >
                        <div className={styles.title}>
                            <span>{question}</span>
                            <div className={styles.button}>
                                <img
                                    width={10}
                                    height={10}
                                    src="/images/answers/cross.svg"
                                    alt="Toggle question description visibility"
                                />
                            </div>
                        </div>
                        <div className={styles.description}>{answer}</div>
                    </button>
                ))}
            </div>
        </section>
    );
};

export default Answers;
